import React from "react";
import { useTranslation } from "react-i18next";
import { cn } from "./ui/utils";
import { setLocale, type AppLocale, normalizeLocale } from "../i18n";
import { maxPlatform } from "../services/maxPlatform";

type Props = {
  className?: string;
  size?: "sm" | "md";
};

export function LanguageSwitcher({ className, size = "sm" }: Props) {
  const { i18n, t } = useTranslation();
  const current = normalizeLocale(i18n.language);

  const pick = (locale: AppLocale) => {
    if (locale === current) return;
    maxPlatform.hapticFeedback("light");
    void setLocale(locale, true);
  };

  const btn =
    size === "sm"
      ? "h-7 min-w-8 px-2 text-[11px]"
      : "h-9 min-w-10 px-3 text-[13px]";

  return (
    <div
      role="group"
      aria-label={t("profile.language")}
      className={cn(
        "inline-flex items-center rounded-full border border-gray-200 bg-white/80 p-0.5",
        className,
      )}
    >
      {(["ru", "en"] as const).map((locale) => (
        <button
          key={locale}
          type="button"
          onClick={() => pick(locale)}
          className={cn(
            "rounded-full font-medium transition-colors",
            btn,
            current === locale
              ? "bg-indigo-600 text-white shadow-sm"
              : "text-gray-500 hover:text-gray-800",
          )}
          aria-pressed={current === locale}
        >
          {t(`common.lang_${locale}`)}
        </button>
      ))}
    </div>
  );
}
